<template>
    <!-- 로딩 -->
    <b-col sm="12" v-if="listLoading">
        <b-row class="selectRow">
            <b-col sm="5"></b-col>
            <b-col sm="5" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
            </b-col>
        </b-row>
    </b-col>
    <b-col sm="12" class="pt-sm-1" v-else>
        <b-row class="selectRow">
            <b-col sm="12">
                <b-table :fields="fields" :items="items" :busy="items == 0">
                    <template slot="mobile" slot-scope="row">
                        {{ row.item.mobile | phoneNumberRegx }}
                    </template>
                    <template slot="check" slot-scope="row">
                        <button type="button" class="btn btn-outline-primary" v-on:click="checkListRows(row.item)">선택</button>
                    </template>
                    <div slot="table-busy" class="text-center my-2">
                        <strong>검색 조건을 이용하여 검색 하여주세요.</strong>
                    </div>
                </b-table>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import { EventBus } from "../../event-bus";

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});

export default {
    name: "userSelectList",
    props: {
        items: {
            type: Array,
        },
        listLoading: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            fields: [
                { authority_name: { label: "계정회원" } },
                { user_id: { label: "아이디" } },
                { name: { label: "이름" } },
                { mobile: { label: "핸드폰번호" } },
                { company_name: { label: "소속회사" } },
                { letter_yn: { label: "마케팅수신동의" } },
                { user_status_name: { label: "상태" } },
                { reg_date: { label: "가입일" } },
                { login_date: { label: "최근로그인" } },
                { check: { label: "선택" } },
            ],
        }
    },
    methods: {
        checkListRows(item){
            EventBus.$emit('callSelectUser', item);
        }
    },
    components: {
        PulseLoader,
    }
}
</script>
<style lang="css" scoped>
.selectRow {
    min-Height: 550px;
    max-Height: 550px;
    overflow-y: auto;
    border: 1px solid #a4b7c1;
}
</style>


// WEBPACK FOOTER //
// src/views/user/common/UserSelectList.vue